module.exports = __webpack_public_path__ + "static/img/zhong13.d0f884c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhong13.png
// module id = FFwA
// module chunks = 16